var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { height: "25vh", padding: "20px" } },
      [
        _c(
          "v-card",
          { attrs: { height: "100%" } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.emptyList,
                    expression: "emptyList"
                  }
                ],
                class: { "grey lighten-2": _vm.dragover },
                staticStyle: { height: "100%" },
                on: {
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.onDrop($event)
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragenter: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  mouseover: function($event) {
                    _vm.dragover = true
                  },
                  mouseleave: function($event) {
                    _vm.dragover = false
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    _vm.dragover = false
                  },
                  click: function($event) {
                    return _vm.$refs.file.click()
                  }
                }
              },
              [
                _c("input", {
                  key: _vm.fileInputKey,
                  ref: "file",
                  staticStyle: { display: "none" },
                  attrs: { type: "file" },
                  on: { change: _vm.onSelectFile }
                }),
                _c("div", { staticClass: "centerDiv" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "centerDiv" },
                      [
                        _c("v-icon", { attrs: { size: "60" } }, [
                          _vm._v("upload")
                        ])
                      ],
                      1
                    ),
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.tfImportFile) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "v-card",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.emptyList,
                    expression: "!emptyList"
                  }
                ],
                attrs: { height: "100%", width: "100%" }
              },
              [
                _c("v-card-title", [
                  _c("h3", [_vm._v(_vm._s(_vm.tfLabelImport))])
                ]),
                _c(
                  "v-card",
                  {
                    staticStyle: {
                      overflow: "auto",
                      "margin-left": "30%",
                      height: "100%",
                      "background-color": "#11ffee00"
                    },
                    attrs: { height: "40vh", width: "40vw", elevation: "0" }
                  },
                  [
                    _c("div", { staticClass: "centerDiv2" }, [
                      _c(
                        "div",
                        _vm._l(_vm.items, function(item, i) {
                          return _c(
                            "div",
                            { key: i, staticStyle: { "margin-bottom": "8px" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "rounded-card font-weight-medium text-h4",
                                  attrs: {
                                    height: "30px",
                                    elevation: "0",
                                    shaped: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.name) +
                                          "\n                    "
                                      ),
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "27px"
                                          },
                                          attrs: { color: "green" }
                                        },
                                        [_vm._v(" checkbox")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            rounded: "",
                                            title: "Eliminar archivo"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.erase(i)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v(" cancel")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          height: "18vh",
          "margin-left": "15px",
          display: "flex",
          "align-items": "center",
          "justify-content": "center"
        }
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabModel == "0",
                expression: "tabModel == '0'"
              }
            ],
            staticClass: "containConfigDiv"
          },
          [
            _c(
              "div",
              {
                staticStyle: { "text-align": "center", "margin-left": "100px" }
              },
              [
                _c(
                  "v-card",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.track3Export,
                        expression: "track3Export"
                      }
                    ],
                    staticClass: "typeTrack3Card",
                    attrs: { elevation: "0", shaped: "" }
                  },
                  [
                    _c("v-card-title", [_vm._v(" Descargar como:")]),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { row: "" },
                        model: {
                          value: _vm.radioGroupTDownloadType,
                          callback: function($$v) {
                            _vm.radioGroupTDownloadType = $$v
                          },
                          expression: "radioGroupTDownloadType"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: {
                                value: "allPolygon",
                                label: "Todos los polígonos en el archivo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: {
                                value: "perPolygon",
                                label: "Polígono por archivo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center", "margin-left": "100px" }
              },
              [
                _c(
                  "v-card",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.track3Export,
                        expression: "track3Export"
                      }
                    ],
                    staticClass: "typeTrack3Card",
                    attrs: { elevation: "0", shaped: "" }
                  },
                  [
                    _c("v-card-title", [_vm._v(" Exportar como:")]),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { row: "" },
                        model: {
                          value: _vm.radioGroupTrack3Type,
                          callback: function($$v) {
                            _vm.radioGroupTrack3Type = $$v
                          },
                          expression: "radioGroupTrack3Type"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: { value: "sitios", label: "Sitios" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isDirector,
                                  expression: "isDirector"
                                }
                              ],
                              staticClass: "align-center justify-center",
                              attrs: { value: "geocercas", label: "Geocercas" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-radio-group",
              {
                attrs: { row: "" },
                model: {
                  value: _vm.radioGroupExport,
                  callback: function($$v) {
                    _vm.radioGroupExport = $$v
                  },
                  expression: "radioGroupExport"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "rbDiv" },
                  [
                    _c("v-radio", {
                      staticClass: "align-center justify-center",
                      attrs: { value: "track3" }
                    }),
                    _vm._v("Exportar para Track3\n        ")
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "rbDiv" },
                  [
                    _c("v-radio", {
                      staticClass: "align-center justify-center",
                      attrs: { value: "navman" }
                    }),
                    _vm._v("Exportar para Navman\n        ")
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "rbDiv" },
                  [
                    _c("v-radio", {
                      staticClass: "align-center justify-center",
                      attrs: { value: "director" }
                    }),
                    _vm._v("Exportar para Director\n        ")
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabModel == "1",
                expression: "tabModel == '1'"
              }
            ],
            staticClass: "containConfigDiv",
            staticStyle: { "margin-left": "inherit !important" }
          },
          [
            _c(
              "div",
              {
                staticStyle: { "text-align": "center", "margin-left": "100px" }
              },
              [
                _c(
                  "v-card",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.track3Export,
                        expression: "track3Export"
                      }
                    ],
                    staticClass: "typeTrack3Card",
                    attrs: { elevation: "0", shaped: "" }
                  },
                  [
                    _c("v-card-title", [_vm._v(" Exportar para:")]),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { row: "" },
                        on: { change: _vm.valideRadioGroupDirector },
                        model: {
                          value: _vm.radioGroupTrack3Type,
                          callback: function($$v) {
                            _vm.radioGroupTrack3Type = $$v
                          },
                          expression: "radioGroupTrack3Type"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: { value: "Track3", label: "Track3 (.csv)" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: { value: "Orvis", label: "Orvis (.kml)" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center", "margin-left": "100px" }
              },
              [
                _c(
                  "v-card",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.track3Export,
                        expression: "track3Export"
                      }
                    ],
                    staticClass: "typeTrack3Card",
                    attrs: { elevation: "0", shaped: "" }
                  },
                  [
                    _c("v-card-title", [_vm._v(" Exportar como:")]),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { row: "" },
                        model: {
                          value: _vm.radioGroupTDownloadType,
                          callback: function($$v) {
                            _vm.radioGroupTDownloadType = $$v
                          },
                          expression: "radioGroupTDownloadType"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: { value: "Sitios", label: "Sitios" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: {
                                value: "Geocercas",
                                label: "Geocercas",
                                disabled: _vm.radioGroupTrack3Type == "Orvis"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rbDivExport" },
                          [
                            _c("v-radio", {
                              staticClass: "align-center justify-center",
                              attrs: {
                                value: "Ambos",
                                label: "Ambos",
                                disabled: _vm.radioGroupTrack3Type == "Orvis"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "containConfigDiv",
            staticStyle: { "margin-left": "2vw" }
          },
          [
            _c(
              "v-btn",
              {
                staticClass: "elevation-0 ",
                class: { "disable-events": _vm.emptyList },
                staticStyle: {
                  height: "7vh",
                  width: "12vw",
                  "margin-right": "45px",
                  background: "#fafafa"
                },
                attrs: { id: "btnExportCSV" },
                on: { click: _vm.exportCsv }
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "importExportBtnIcon",
                    attrs: { "x-large": "" }
                  },
                  [_vm._v("cloud_download")]
                ),
                _vm._v("      " + _vm._s(_vm.btnExport) + "\n      ")
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }